import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

export const storyblokProductSearchFiltersGetSets = (): Partial<
  Pick<StoryblokProductSearchFiltersType, 'ribbonText'>
> => {
  return {
    ribbonText: ['Sparset', 'Sparpaket'],
  }
}
